<div
  class="forms-modal-shell"
  [class.forms-modal-shell--hidden]="isMinimized"
>
  <div class="modal-header d-flex justify-content-between">
    <h4 class="modal-title">{{ title }}</h4>
    <button
      class="bg-transparent border-0 fs-6"
      type="button"
      aria-label="Close"
      (click)="closingModal()"
    >
      <i class="fas fa-times dark"></i>
    </button>
  </div>
  <div class="modal-body">
    <ng-container #dynamicComponentContainer></ng-container>

    @if (isEditForm && tipoTransaccion === TYPE_TRANSACTION.FINANCIAL) {
      <div class="chat-bubble" (click)="toggleChat()">
        <i class="fas fa-image"></i>
        @if (documents.length > 0) {
          <span class="badge-count">{{ documents.length }}</span>
        }
      </div>

      <div
        class="chat-container"
        [class.chat-open]="isChatOpen"
        [class.showing-pdf]="
          isChatOpen && documents.length > 0 && isPdf(documents[currentIndex])
        "
      >
        <div class="chat-header">
          <h5>Respaldo Movimiento Financiero</h5>
          @if (documents.length > 1) {
            <span class="doc-counter"
              >{{ currentIndex + 1 }} / {{ documents.length }}</span
            >
          }
        </div>

        <div class="chat-body">
          @if (documents.length === 0) {
            <div class="no-documents">
              <i class="fas fa-folder-open"></i>
              <p>No hay documentos adjuntos</p>
            </div>
          } @else {
            <div
              class="carousel-viewer"
              [class.pdf-viewer]="isPdf(documents[currentIndex])"
            >
              @if (isPdf(documents[currentIndex])) {
                @if (pdfReady) {
                  <object
                    [data]="documents[currentIndex].safeUrl"
                    type="application/pdf"
                    class="pdf-object"
                  >
                    <div class="pdf-fallback">
                      <i class="fas fa-file-pdf"></i>
                      <p>No se puede mostrar el PDF en el visor.</p>
                      <a
                        [href]="documents[currentIndex].safeUrl"
                        target="_blank"
                        class="btn-open-pdf"
                      >
                        <i class="fas fa-external-link-alt"></i> Abrir en nueva
                        pestaña
                      </a>
                    </div>
                  </object>
                } @else {
                  <div class="pdf-loading">
                    <i class="fas fa-spinner fa-spin"></i>
                  </div>
                }
              } @else {
                <img
                  [src]="documents[currentIndex].safeUrl"
                  [alt]="documents[currentIndex].nombre_documento"
                  (click)="openFullscreen()"
                />
              }

              @if (documents.length > 1) {
                <button
                  class="carousel-nav prev"
                  (click)="prevDocument()"
                  [disabled]="currentIndex === 0"
                >
                  <i class="fas fa-chevron-left"></i>
                </button>
                <button
                  class="carousel-nav next"
                  (click)="nextDocument()"
                  [disabled]="currentIndex === documents.length - 1"
                >
                  <i class="fas fa-chevron-right"></i>
                </button>
              }
            </div>

            <div class="carousel-actions">
              <button
                class="btn-action btn-download"
                (click)="downloadDocument()"
              >
                <i class="fas fa-download"></i>
                Descargar
              </button>
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>

@if (isMinimized) {
  <button
    type="button"
    class="forms-modal-fab"
    [class.forms-modal-fab--repeated-vouchers]="
      title === 'Comprobantes repetidos'
    "
    (click)="restoreModal()"
    aria-label="Restaurar modal"
  >
    <i class="fas fa-window-restore"></i>
    <span>{{ title }}</span>
  </button>
}
